'use client'

import Link from 'next/link'
import { useTheme } from '@/contexts/ThemeContext'

export default function WhatIsFreedivingPage() {
  const { theme } = useTheme()

  return (
    <div className={`min-h-screen py-6 xxs:py-3 px-4 xxs:px-2 ${
      theme === 'light'
        ? 'bg-gradient-to-b from-blue-50 to-white'
        : 'bg-gradient-to-b from-gray-900 to-gray-800'
    }`}>
      <div className="max-w-4xl mx-auto">
        <Link href="/guide" className={`hover:underline mb-3 xxs:mb-2 inline-block text-sm xxs:text-xs ${
          theme === 'light' ? 'text-blue-600' : 'text-blue-400'
        }`}>
          ← 입문 가이드 목록
        </Link>

        <article className={`rounded-lg shadow-xl p-6 xxs:p-3 ${
          theme === 'light' ? 'bg-white' : 'bg-gray-800'
        }`}>
          <h1 className={`text-2xl xxs:text-lg font-bold mb-4 xxs:mb-3 ${
            theme === 'light' ? 'text-gray-900' : 'text-white'
          }`}>프리다이빙이란?</h1>

          <div className="max-w-none">
            <p className={`text-sm xxs:text-xs mb-4 xxs:mb-3 ${
              theme === 'light' ? 'text-gray-600' : 'text-gray-400'
            }`}>
              프리다이빙(Freediving)은 공기탱크 없이 숨을 참고 물속으로 잠수하는 수중 스포츠입니다.
            </p>

            <h2 className={`text-base xxs:text-sm font-bold mt-6 xxs:mt-4 mb-3 xxs:mb-2 ${
              theme === 'light' ? 'text-gray-900' : 'text-white'
            }`}>프리다이빙의 매력</h2>
            <ul className={`space-y-2 xxs:space-y-1.5 text-xs xxs:text-[10px] ${
              theme === 'light' ? 'text-gray-600' : 'text-gray-400'
            }`}>
              <li>🌊 <strong>자유로움</strong>: 무거운 장비 없이 물속을 자유롭게 이동</li>
              <li>🧘 <strong>명상 효과</strong>: 호흡 조절을 통한 정신 집중과 이완</li>
              <li>💪 <strong>체력 향상</strong>: 전신 근육 발달과 심폐 기능 강화</li>
              <li>🏊 <strong>접근성</strong>: 다이빙풀에서도 충분히 즐길 수 있음</li>
            </ul>

            <h2 className={`text-base xxs:text-sm font-bold mt-6 xxs:mt-4 mb-3 xxs:mb-2 ${
              theme === 'light' ? 'text-gray-900' : 'text-white'
            }`}>프리다이빙의 종류</h2>
            <div className={`space-y-3 xxs:space-y-2 text-xs xxs:text-[10px] ${
              theme === 'light' ? 'text-gray-600' : 'text-gray-400'
            }`}>
              <div>
                <h3 className={`font-semibold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>1. 풀 프리다이빙 (Pool Freediving)</h3>
                <p>다이빙풀에서 수심을 측정하거나 거리를 측정하는 형태</p>
              </div>
              <div>
                <h3 className={`font-semibold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>2. 오픈워터 프리다이빙 (Open Water)</h3>
                <p>바다나 호수에서 즐기는 실전 프리다이빙</p>
              </div>
              <div>
                <h3 className={`font-semibold text-sm xxs:text-xs ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>3. 컴피티션 프리다이빙 (Competition)</h3>
                <p>깊이, 거리, 시간 등을 겨루는 경쟁 종목</p>
              </div>
            </div>

            <div className={`mt-6 xxs:mt-4 p-4 xxs:p-3 rounded-lg ${
              theme === 'light' ? 'bg-blue-50' : 'bg-blue-900/20'
            }`}>
              <h3 className={`font-bold text-base xxs:text-sm mb-2 xxs:mb-1.5 ${
                theme === 'light' ? 'text-gray-900' : 'text-white'
              }`}>프리다이빙 시작하기</h3>
              <p className={`text-xs xxs:text-[10px] mb-3 xxs:mb-2 ${
                theme === 'light' ? 'text-gray-600' : 'text-gray-400'
              }`}>
                프리다이빙에 관심이 생기셨나요? 가까운 다이빙풀에서 강습을 시작해보세요!
              </p>
              <Link
                href="/map"
                className="inline-block px-4 xxs:px-3 py-2 xxs:py-1.5 text-xs xxs:text-[10px] bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                전국 다이빙풀 찾기
              </Link>
            </div>
          </div>
        </article>
      </div>
    </div>
  )
}
